export const MODAL_TYPE_DISCONNECT_PLAN = 'disconnect-plan';
